/**
 * CommentEmoticon
 */
import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';

let count = 0;

class CommentEmoticon {

	public onUpload: any;

	public onUploadBefore: any;

	private $node: any;

	private $parent: any;

	private $tmp: any;

	private id: string;

	private emoticonBtn: string;

	private _id: string;

	constructor( $node: any, $parent: any ) {
		this.$node = $node;
		this.$parent = $parent;
		this.id = $node.attr( 'id' );

		this._id = `commentEmoticonLayer${++count}`;

		this.onUpload = new Util.Observer();
		this.onUploadBefore = new Util.Observer();

		this.addSelector();
		this.reset();
		this.addEvent();
	}

	public show() {
		this.onUploadBefore.emit();
		jQuery( `#${this._id}` ).addClass( 'active' );
	}

	public hide() {
		jQuery( `#${this._id}` ).removeClass( 'active' );
	}

	private reset() {
		this.$tmp = jQuery( this.layerTemplate() );
		this.$parent.append( this.$tmp );
	}

	private addSelector() {
		this.emoticonBtn = `#${ this.id } .btn-emoticon`;
	}

	private template( url: string ) {
		const _w = Config.attachedEmoticonsSize.w || 140;
		const _h = Config.attachedEmoticonsSize.h || 140;
		return `<img src="${ url }" class="comment-emoticon" alt="" width="${ _w }" height="${ _h }" />`;
	}

	private emoticonsTemplate() {
		if ( !Config.emoticons.length ) {
			return '';
		}

		const _emoticon = Util.Tmpl.iterate({
			data: Config.emoticons,
			template: ( emoticon: string ) => {
				return `<li class="emoticon-items"><img src="${emoticon}" class="comment-emoticon" data-emoticon="true" alt=""></li>`;
			},
		});

		return _emoticon;
	}

	private layerTemplate() {
		return Util.Tmpl.render({
			data: `append emoticon`,
			template: ( name?: string ) => `<div id="${this._id}" class="fe-layer-emoticon">
				<div class="fe-layer-header">
				<h2 class="fe-layer-title">${Config.L10N.emoticon}</h2>
				<button class="fe-btn fe-btn-close"><i class="editor-icon-close"></i></button>
				</div>
				<div class="fe-layer-body">
				<div class="emoticon-wrap">
				<ul class="emoticon-list">
				${ this.emoticonsTemplate() }
				</ul>
				</div>
				</div>
				</div>`,
		});
	}

	private isLogin() {
		if ( !Config.guid ) {
			Config.apiError( {status: 401} );
			return false;
		}

		return true;
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', this.emoticonBtn, ( evt ) => {
			evt.preventDefault();
			const $this = jQuery( evt.target );
			const $parent = $this.parents( 'div.comment-article' );
			const commentId = $parent.attr( 'data-commentid' );

			if ( !this.isLogin() ) {
				return;
			}

			Config.currentCommentIdForUpload = commentId || '';

			let _$thisLayer = jQuery( `#${this._id}` );

			if ( _$thisLayer.length === 0 ) {
				this.reset();
				_$thisLayer = jQuery( `#${this._id}` );
			}

			$this.parents( '.comment-form' ).append( jQuery( `#${this._id}` ) );

			this.show();
		});

		jQuery( 'body' ).on( 'click', `#${this._id} .comment-emoticon`, ( evt ) => {
			const _$this = jQuery( evt.currentTarget );
			this.onUpload.emit( this.template( _$this.attr( 'src' ) ) );
			this.hide();
		});

		jQuery( 'body' ).on( 'click', `#${this._id} .fe-btn-close`, ( evt ) => {
			this.hide();
		});

		jQuery( 'body' ).on( 'click' , ( evt ) => {
			const $thisForm = jQuery( `#${this._id}` );
			const $emoticonBtn = jQuery( this.emoticonBtn );

			if ( !$thisForm.is( evt.target ) &&
				$thisForm.has( evt.target ).length === 0 &&
				$thisForm.hasClass( 'active' ) &&
				!$emoticonBtn.is( evt.target ) &&
				$emoticonBtn.has( evt.target ).length === 0 ) {
					this.hide();
				}
		});
	}
}

export default CommentEmoticon;
